import React, { useState, useReducer } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  MenuItem,
  useMediaQuery,
  withStyles,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
  TextField,
  TextareaAutosize,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import divisions from "../divisions.json";
export default function JoinPage() {
  return (
    <>
      <Box>
        <JoinContent />
      </Box>
    </>
  );
}

//ANHCOR JoinContent
function JoinContent() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    backImg: {
      height: "calc( 100vh - 64px  )",
      width: "100%",
      objectFit: "fill",
    },
    formBox: {
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "50%",
      transform: "translateX(-50%)",
      width: "100%",
    },
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .MuiInputBase-input ": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box position="relative">
        <Box width="100%">
          <img
            src="/assets/images/Search/detailSearch.png"
            className={classes.backImg}
          />
        </Box>
        <Box className={classes.formBox}>
          {/* <SearchForm2/> */}
          <SearchForm />
        </Box>
      </Box>
    </div>
  );
}

function SearchForm() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const { handleSubmit, control, getValues, setValue } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      district: "",
      subdistrict: "",
    },
  });
  const district = useWatch({ control, name: "district" });
  const divisionList = Object.keys(divisions);
  const subdistrictList = district
    ? Object.keys(divisions[district]["subdivisions"])
    : [];
  function _submit(data) {
    const userInput = {
      ...data,
    };
  }
  return (
    <Container maxWidth="lg" style={{ height: "100%" }}>
      <Box py={4} className={classes.formGrid}>
        {/* form area */}
        <Grid container>
          {/* title */}
          <Grid xs={12} item>
            <Box color="#fff" mb={isTable ? 4 : 6}>
              <Typography variant={isTable ? "h4" : "h2"} align="center">
                我要加盟
              </Typography>
            </Box>
          </Grid>
          {/* title area end */}
          {/* form */}
          <Grid
            container
            xs={12}
            justify={isPhone ? "space-between" : "flex-start"}
            spacing={isTable ? "2" : "4"}
          >
            {/* ANCHOR 姓名 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請輸入姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#fff" }}
                    >
                      姓名
                    </Typography>

                    <TextField
                      placeholder="姓名"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR Line 帳號 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="lineId"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#fff" }}
                    >
                      Line帳號
                    </Typography>
                    <TextField
                      // label="Line帳號"
                      placeholder="Line帳號"
                      {...field}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 電話 */}
            <Grid item md={4} xs={12}>
              <Controller
                name="mobile"
                control={control}
                rules={{
                  required: "請輸入電話",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#fff" }}
                    >
                      電話
                    </Typography>
                    <TextField
                      placeholder="電話"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 縣市 */}
            <Grid item md={4} xs={6}>
              <Controller
                control={control}
                name="district"
                rules={{
                  required: "縣市為必填選項",
                }}
                render={({
                  field: { onChange, ...otherField },
                  fieldState: { error },
                }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    error={error}
                  >
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#fff" }}
                    >
                      縣市
                    </Typography>
                    <Select
                      {...otherField}
                      onChange={(e) => {
                        setValue("subdistrict", "");
                        onChange(e);
                      }}
                    >
                      {divisionList.map((item) => (
                        <MenuItem value={item}>
                          {divisions[item]["zhTW"]}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{error && error.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            {/* ANCHOR 鄉鎮 */}
            <Grid item md={4} xs={6}>
              <Controller
                control={control}
                name="subdistrict"
                rules={{
                  required: "地區為必填選項",
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={error}
                    fullWidth
                  >
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#fff" }}
                    >
                      地區
                    </Typography>
                    <Select {...field} disabled={!district}>
                      {subdistrictList.map((item) => (
                        <MenuItem value={item}>
                          {divisions[district]["subdivisions"][item]["zhTW"]}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{error && error.message}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            {/* ANCHOR 備註 */}
            <Grid item xs={12}>
              <TextareaAutosize
                name="message"
                placeholder="備註"
                style={{
                  height: "60px",
                  width: "100%",
                  resize: "none",
                  fontSize: "1em",
                  padding: "10px",
                }}
                className={classes.textarea}
              />
            </Grid>
          </Grid>
          {/* form area end */}
        </Grid>
        {/* button */}

        <Box mt="auto" display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={handleSubmit(_submit)}
            fullWidth
            style={{
              color: "#fff",
              backgroundColor: theme.palette.secondary.light,
              borderRadius: "40px",
              height: "50px",
              width: isTable ? "100%" : "30%",
            }}
          >
            送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
